import { Network } from '@kattana-io/common';
import { SET_NETWORK } from '../actions/network';

export interface INetworkState {
  selected: Network;
}

const defaultNetworkState: INetworkState = {
  selected: Network.fromChainId(1),
};

const networkReducer = (
  state: INetworkState = defaultNetworkState,
  action: any
): INetworkState => {
  switch (action.type) {
  case SET_NETWORK:
    return {
      ...state,
      selected: action.payload,
    };
  default:
    return state;
  }
};

export default networkReducer;
